"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pickProps;
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function pickProps(props, targetProps) {
  var pickedProps = {};
  Object.keys(targetProps).forEach(function (key) {
    if (props[key] !== undefined) {
      pickedProps[key] = props[key];
    }
  });

  return pickedProps;
}